import React, { memo, useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import moment from 'moment';
// @ts-ignore
import { isEqual } from 'lodash-es';
import { useMemoizedFn } from 'ahooks';
// import { DatePicker } from 'tea-component';
// import useMonthPickerInputReadonly from '@gp/hooks/useMonthPickerInputReadonly';
// import GPSelectMultiple from '@gp/components/SelectMultiple';
import DropDownSelect from '@gp/components/DropDownSelect';
import { isValidNumber } from '@gp/utils/common';
import { SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX } from '@gp/constants/const';
import './index.scss';

// const { MonthPicker } = DatePicker;

interface IFilterProps extends IBaseProps {
  studioId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  // projects: IStudioOverallDetailsProject[];
  // updateProjects: (
  //   studioId: string,
  //   date: string,
  // ) => Promise<IStudioOverallDetailsProject[]>;
  value?: IStudioOverallDetailsFilter;
  onConfirm?: (payload: IStudioOverallDetailsFilter) => void;
}

const Filter: React.FC<IFilterProps> = (props) => {
  const {
    studioId,
    dateRange,
    // projects,
    // updateProjects,
    value,
    onConfirm,
    style,
    className,
    ...remains
  } = props;

  const [filter, setFilter] = useState<IStudioOverallDetailsFilter>({
    date: '',
    projects: [],
  });

  /* const dateM = useMemo(() => {
    const m = moment(filter?.date);
    return m.isValid() ? m : undefined;
  }, [filter?.date]); */

  const isDatePickerDisabled = useMemo(
    () => !dateRange?.startDate || !dateRange?.endDate,
    [dateRange?.startDate, dateRange?.endDate],
  );

  const yearsOptions = useMemo(() => {
    const res: {
      text: string,
      value: string,
    }[] = [];
    const startYear = typeof dateRange?.startDate === 'string' ? dateRange?.startDate?.slice(0, 4) || '' : '',
          endYear = typeof dateRange?.endDate === 'string' ? dateRange?.endDate?.slice(0, 4) || '' : '';
    if (!isValidNumber(startYear) || !isValidNumber(endYear)) return res;
    for(let i = Number(startYear); i <= Number(endYear); i ++) {
      const t = String(i);
      res.push({
        text: t,
        value: t,
      });
    }

    return res;
  }, [dateRange]);

  /* const dateRangeM = useMemo<[moment.Moment, moment.Moment]>(() => {
    const { startDate, endDate } = dateRange || {};
    return [moment(startDate), moment(endDate)];
  }, [dateRange]);

  const handleDateChange = useMemoizedFn(async (value: moment.Moment) => {
    const dateStr = value?.isValid() ? value?.format('YYYY-MM-DD') : '';
    const projectsTemp = await updateProjects(studioId, dateStr);
    const newFilter = {
      ...filter,
      date: dateStr,
      projects: projectsTemp.map((project) => project?.id),
    };
    setFilter(newFilter);
    onConfirm?.(newFilter);
  }); */

  // const monthPicker = useMonthPickerInputReadonly();

  const handleDateChange = useMemoizedFn((
    data: {
      value: string,
      options: any[],
    },
  ) => {
    const newFilter = {
      ...filter,
      date: data?.value,
    };
    setFilter(newFilter);
    onConfirm?.(newFilter);
  });

  useEffect(() => {
    if (isEqual(value, filter)) return;
    setFilter({ ...filter, ...value });
  }, [value]);

  return (
    <div
      {...remains}
      style={style}
      className={classnames(
        'dbg-studio-overall-details-finance-filter',
        className,
      )}
    >
      {/* <MonthPicker
        // ref={monthPicker}
        className={classnames('gp-common-month-picker', {
          // REMARK: MonthPicker筛选器 禁用时 需要 通过 gp-common-month-picker、disabled 两个className 来控制加禁用态UI，tea组件库 没有禁用态UI
          disabled: isDatePickerDisabled,
        })}
        style={{ marginRight: 10 }}
        disabled={isDatePickerDisabled}
        range={dateRangeM}
        value={dateM}
        onChange={handleDateChange}
      /> */}
      <DropDownSelect
        className=""
        allOpt={{
          placeholder: `Please select Date`,
          disabled: isDatePickerDisabled,
          clearable: false,
          staging: false,
          listHeight: SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX,
          isValueControlled: true,
          values: filter?.date,
          options: yearsOptions,
        }}
        onChange={handleDateChange}
      />
    </div>
  );
};

export default memo(Filter);
